import { Buffer } from 'buffer';

// Make Buffer available globally for @ton/core
(window as any).Buffer = Buffer;
(globalThis as any).Buffer = Buffer;
